export default {
  id: 229,
  title: 'Target #229 - Flower',
  url: 'https://cssbattle.dev/play/229',
  colors: ['#F4DCBF', '#D95362'],
  solution:
    '<p a><p b><p c><style>p[a],p[b]{left:125;width:60;height:120;background:#d95362}p[a],p[b],p[c]{background:#d95362}body{background:#f4dcbf}p{position:fixed;margin:0}p[a]{top:15;border-radius:0 1in;box-shadow:90px 150px #d95362}p[b]{bottom:15;border-radius:1in 0;box-shadow:90px -150px #d95362}p[c]{top:135;left:185;width:30;height:30',
}
